import 'leaflet/dist/leaflet.css';
import "leaflet-easybutton/src/easy-button.js";
import "leaflet-easybutton/src/easy-button.css";
import "font-awesome/css/font-awesome.min.css";

import "./mapStyle.css"

import Box from '@mui/material/Box';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Switch from '@mui/material/Switch';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import MoneyIcon from '@mui/icons-material/Money';
import PublicIcon from '@mui/icons-material/Public';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import Button from "@mui/material/Button";
import {Checkbox, FormControlLabel, MenuItem, Select, Tab, Tabs} from "@mui/material";
import StarIcon from '@mui/icons-material/Star';
import SchoolIcon from "@mui/icons-material/School";
import WalletIcon from "@mui/icons-material/Wallet";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import CloseIcon from '@mui/icons-material/Close';
import React, {useEffect, useState} from "react";
import RemoveIcon from '@mui/icons-material/Remove';
import BalconyOutlinedIcon from '@mui/icons-material/BalconyOutlined';
import ElevatorOutlinedIcon from '@mui/icons-material/ElevatorOutlined';
import Cookies from 'universal-cookie';
import { HomeTypeIcon, HomeTypeSvgIcon } from './homeTypeIcons.js';
import { formatListingsUpdated, useListingsUpdatedAt } from './listingsStatus.js';
import CommuteFilter from './CommuteFilter.js';
import { applyCommuteDraft, isCommuteDraftPending, useCommute, useCommuteDraft } from './commute.js';
import { readSavedFilters, saveFilters } from './savedFilters.js';
import { ThemeProvider, CssBaseline, createTheme } from '@mui/material';
import {height} from "@mui/system";
import { track } from '../analytics/events.js';
import ScoreRangeBar from './ScoreRangeBar.js';
import PriceRangeBar, { FeeRangeBar } from './PriceRangeBar.js';


const FULL_RANGE = [1, 6];
const isFullScoreRange = (range) => !Array.isArray(range) || (Number(range[0]) <= 1 && Number(range[1]) >= 6);
// Whether the area filter shows the separate scores ("Detaljerat") instead of the total. Saved on its
// own so it survives switching view and reloading; only the shown scores are applied.
const AREA_DETAILED_COOKIE = 'area_filter_detailed';
const NEW_CONSTRUCTION_VALUES = ['all', 'only', 'exclude'];

const FilterList = ({
                        languageState,
                        checkedState,
                        handleChange,
                        setDrawerTab,
                        setOpen,
                        open,
                        setCustomFilterActive,
                        setCustomFilter,
                        setKey,
                        setListingFilters,
                        onApplyListingSearch,
                        // Called just before changed filters are applied, so the view can animate what changes.
                        onBeforeApply,
                        getPriceHistogram,
                        priceHistogramScope,
                        // Kartvy has its own Färgkarta menu on the toolbar.
                        showMapSwitches = true,
                        // Listvy's phone/tablet "Fler filter" button, shown above the search button.
                        expandToggle = null,
                        // When the Restid section asks for its intro tip: 'open' as it mounts (a drawer, sheet or panel
                        // that opened), 'interact' at the first touch (listvy's always-open filter column).
                        commuteIntroTip = 'open'
                    }) => {

    const betaVersion = false;
    const listingsUpdatedAt = useListingsUpdatedAt();

    const [totalValue, setTotalValue] = React.useState([1, 6]);
    const [apartmentValue, setApartmentValue] = React.useState([1, 6]);
    const [houseValue, setHouseValue] = React.useState([1, 6]);
    const [educationValue, setEducationValue] = React.useState([1, 6]);
    const [incomeValue, setIncomeValue] = React.useState([1, 6]);
    const [unemploymentValue, setUnemploymentValue] = React.useState([1, 6]);
    const [ownedValue, setOwnedValue] = React.useState([1, 6]);
    const [areaDetailed, setAreaDetailed] = React.useState(() => {
        const saved = new Cookies().get(AREA_DETAILED_COOKIE);
        return saved === true || saved === 'true';
    });

    const [selectedTab, setSelectedTab] = useState("house");
    const [value, setValue] = React.useState('one');
    const [houseType, setHosueType] = React.useState('all');
    const [priceMin, setPriceMin] = React.useState('min');
    const [priceMax, setPriceMax] = React.useState('max');
    const [roomMin, setRoomMin] = React.useState('min');
    const [roomMax, setRoomMax] = React.useState('max');
    const [sqmMin, setSqmMin] = React.useState('min');
    const [sqmMax, setSqmMax] = React.useState('max');
    const [feeMax, setFeeMax] = React.useState('max');
    const [sqmPriceMin, setSqmPriceMin] = React.useState('min');
    const [sqmPriceMax, setSqmPriceMax] = React.useState('max');
    const [floorMin, setFloorMin] = React.useState('min');
    const [floorMax, setFloorMax] = React.useState('max');
    const [yearBuiltMin, setYearBuiltMin] = React.useState('min');
    const [yearBuiltMax, setYearBuiltMax] = React.useState('max');
    const [balcony, setBalcony] = React.useState(false);
    const [elevator, setElevator] = React.useState(false);
    // Nyproduktion: 'all', 'only' or 'exclude'.
    const [newConstruction, setNewConstruction] = React.useState('all');
    const prevOpenRef = React.useRef(open);

    const cookies = new Cookies();

    const theme = createTheme();

    const serializeFormState = (state) => JSON.stringify({
        houseType: state.houseType,
        priceMin: state.priceMin,
        priceMax: state.priceMax,
        roomMin: state.roomMin,
        roomMax: state.roomMax,
        sqmMin: state.sqmMin,
        sqmMax: state.sqmMax,
        feeMax: state.feeMax,
        sqmPriceMin: state.sqmPriceMin,
        sqmPriceMax: state.sqmPriceMax,
        floorMin: state.floorMin,
        floorMax: state.floorMax,
        yearBuiltMin: state.yearBuiltMin,
        yearBuiltMax: state.yearBuiltMax,
        balcony: Boolean(state.balcony),
        elevator: Boolean(state.elevator),
        newConstruction: state.newConstruction || 'all',
        totalValue: state.totalValue,
        apartmentValue: state.apartmentValue,
        houseValue: state.houseValue,
        incomeValue: state.incomeValue,
        unemploymentValue: state.unemploymentValue,
        ownedValue: state.ownedValue,
        educationValue: state.educationValue,
        areaDetailed: Boolean(state.areaDetailed),
    });

    const [appliedFormStateKey, setAppliedFormStateKey] = useState(() => serializeFormState({
        houseType: 'all',
        priceMin: 'min',
        priceMax: 'max',
        roomMin: 'min',
        roomMax: 'max',
        sqmMin: 'min',
        sqmMax: 'max',
        feeMax: 'max',
        sqmPriceMin: 'min',
        sqmPriceMax: 'max',
        floorMin: 'min',
        floorMax: 'max',
        yearBuiltMin: 'min',
        yearBuiltMax: 'max',
        balcony: false,
        elevator: false,
        newConstruction: 'all',
        totalValue: [1, 6],
        apartmentValue: [1, 6],
        houseValue: [1, 6],
        incomeValue: [1, 6],
        unemploymentValue: [1, 6],
        ownedValue: [1, 6],
        educationValue: [1, 6],
        areaDetailed: false,
    }));

    const wrapAfterWords = (text, maxWords) => {
        const words = text.split(' ');
        if (words.length <= maxWords) {
            return text;
        }
        return `${words.slice(0, maxWords).join(' ')}\n${words.slice(maxWords).join(' ')}`;
    };

    const tooltipTextByKey = {
        mapLegend: wrapAfterWords(
            languageState.swedish
                ? 'Färgkartans färgas utifrån det värde som är togglat . Välj Betyh för ett sammanvägt betyg.'
                : 'The colour map is recoloured based on the toggled metric. Choose Ranking for a combined score.',
            6
        ),
        areaFilter: wrapAfterWords(
            languageState.swedish
                ? 'Områden inom valt spann visas i färg. Övriga gråas ut.'
                : 'Areas within the selected range stay colored; others are dimmed.',
            6
        ),
        squareMeterPriceApartment: languageState.swedish
            ? 'Lägenhet kr/m².'
            : 'Apartment SEK/m².',
        squareMeterPriceHouse: languageState.swedish
            ? 'Hus kr/m².'
            : 'House SEK/m².',
        ownedVsRented: languageState.swedish
            ? 'Boendeform (ägande).'
            : 'Housing type (ownership).',
        education: languageState.swedish
            ? 'Visar andel högutbildade.'
            : 'Shows share with higher education.',
        income: languageState.swedish
            ? 'Visar nettoinkomst per månad. Lön och kapital.'
            : 'Shows net income per month. Salary and capital.',
        unemployment: languageState.swedish
            ? 'Visar arbetslöshet (lägre är bättre).'
            : 'Shows unemployment (lower is better).',
        totalScore: languageState.swedish
            ? 'Visar sammanvägt betyg.'
            : 'Shows combined score.',
    };

    const getInfoIcon = (key) => (
        <span className="infoIcon drawerInfoIcon" data-tooltip={tooltipTextByKey[key]}>i</span>
    );

    const sqmOptions = [...Array.from({ length: 40 }, (_, index) => (index + 1) * 10), 450, 500, 550, 600, 700, 800, 900, 1000];
    const sqmPriceOptions = [...Array.from({ length: 15 }, (_, index) => (index + 1) * 10000), 175000, 200000];
    // 0 is the ground floor.
    const floorOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 15, 20];
    const floorLabel = (value) => (value === 0 ? (languageState.swedish ? 'Bottenvåning' : 'Ground floor') : String(value));
    const yearBuiltOptions = [1900, 1920, 1930, 1940, 1950, 1960, 1970, 1980, 1990, 2000, 2005, 2010, 2015, 2020, 2025];
    const formatKronor = (value) => Number(value).toLocaleString('sv-SE').replace(/\s+/g, ' ');



    useEffect(() => {
            let initialTotalValue = [1, 6];
            let initialApartmentValue = [1, 6];
            let initialHouseValue = [1, 6];
            let initialEducationValue = [1, 6];
            let initialIncomeValue = [1, 6];
            let initialUnemploymentValue = [1, 6];
            let initialOwnedValue = [1, 6];
            let initialHouseType = 'all';
            let initialPriceMin = 'min';
            let initialPriceMax = 'max';
            let initialRoomMin = 'min';
            let initialRoomMax = 'max';
            let initialSqmMin = 'min';
            let initialSqmMax = 'max';
            let initialFeeMax = 'max';
            let initialSqmPriceMin = 'min';
            let initialSqmPriceMax = 'max';
            let initialFloorMin = 'min';
            let initialFloorMax = 'max';
            let initialYearBuiltMin = 'min';
            let initialYearBuiltMax = 'max';
            let initialBalcony = false;
            let initialElevator = false;
            let initialNewConstruction = 'all';

            // The filters last applied (savedFilters.js); the views already start from them.
            const saved = readSavedFilters();
            if (saved.hasCustomFilter) {
                const parsedFilters = saved.customFilter;
                initialTotalValue = parsedFilters.totalScore;
                initialApartmentValue = parsedFilters.apartment;
                initialHouseValue = parsedFilters.house;
                initialEducationValue = parsedFilters.education;
                initialIncomeValue = parsedFilters.income;
                initialUnemploymentValue = parsedFilters.unemployment;
                initialOwnedValue = parsedFilters.owned;
                setTotalValue(initialTotalValue);
                setApartmentValue(initialApartmentValue);
                setHouseValue(initialHouseValue);
                setEducationValue(initialEducationValue);
                setIncomeValue(initialIncomeValue);
                setUnemploymentValue(initialUnemploymentValue);
                setOwnedValue(initialOwnedValue);
            }

            if (saved.hasListingFilters) {
                const normalizedListingFilters = saved.listingFilters;
                initialHouseType = normalizedListingFilters.houseType;
                initialPriceMin = normalizedListingFilters.priceMin;
                initialPriceMax = normalizedListingFilters.priceMax;
                initialRoomMin = normalizedListingFilters.roomMin;
                initialRoomMax = normalizedListingFilters.roomMax;
                initialSqmMin = normalizedListingFilters.sqmMin;
                initialSqmMax = normalizedListingFilters.sqmMax;
                initialFeeMax = normalizedListingFilters.feeMax;
                initialSqmPriceMin = normalizedListingFilters.sqmPriceMin;
                initialSqmPriceMax = normalizedListingFilters.sqmPriceMax;
                initialFloorMin = normalizedListingFilters.floorMin;
                initialFloorMax = normalizedListingFilters.floorMax;
                initialYearBuiltMin = normalizedListingFilters.yearBuiltMin;
                initialYearBuiltMax = normalizedListingFilters.yearBuiltMax;
                initialBalcony = normalizedListingFilters.balcony;
                initialElevator = normalizedListingFilters.elevator;
                initialNewConstruction = normalizedListingFilters.newConstruction;
                setHosueType(normalizedListingFilters.houseType);
                setPriceMin(normalizedListingFilters.priceMin);
                setPriceMax(normalizedListingFilters.priceMax);
                setRoomMin(normalizedListingFilters.roomMin);
                setRoomMax(normalizedListingFilters.roomMax);
                setSqmMin(normalizedListingFilters.sqmMin);
                setSqmMax(normalizedListingFilters.sqmMax);
                setFeeMax(normalizedListingFilters.feeMax);
                setSqmPriceMin(normalizedListingFilters.sqmPriceMin);
                setSqmPriceMax(normalizedListingFilters.sqmPriceMax);
                setFloorMin(normalizedListingFilters.floorMin);
                setFloorMax(normalizedListingFilters.floorMax);
                setYearBuiltMin(normalizedListingFilters.yearBuiltMin);
                setYearBuiltMax(normalizedListingFilters.yearBuiltMax);
                setBalcony(normalizedListingFilters.balcony);
                setElevator(normalizedListingFilters.elevator);
                setNewConstruction(normalizedListingFilters.newConstruction);
            }

            // Saved before the switch existed: detailed scores in use mean the detailed view.
            let initialAreaDetailed = areaDetailed;
            const savedDetailed = cookies.get(AREA_DETAILED_COOKIE);
            if (savedDetailed === undefined) {
                initialAreaDetailed = [initialApartmentValue, initialHouseValue, initialEducationValue,
                    initialIncomeValue, initialUnemploymentValue, initialOwnedValue].some((range) => !isFullScoreRange(range));
                setAreaDetailed(initialAreaDetailed);
            }

            setAppliedFormStateKey(serializeFormState({
                houseType: initialHouseType,
                priceMin: initialPriceMin,
                priceMax: initialPriceMax,
                roomMin: initialRoomMin,
                roomMax: initialRoomMax,
                sqmMin: initialSqmMin,
                sqmMax: initialSqmMax,
                feeMax: initialFeeMax,
                sqmPriceMin: initialSqmPriceMin,
                sqmPriceMax: initialSqmPriceMax,
                floorMin: initialFloorMin,
                floorMax: initialFloorMax,
                yearBuiltMin: initialYearBuiltMin,
                yearBuiltMax: initialYearBuiltMax,
                balcony: initialBalcony,
                elevator: initialElevator,
                newConstruction: initialNewConstruction,
                totalValue: initialTotalValue,
                apartmentValue: initialApartmentValue,
                houseValue: initialHouseValue,
                incomeValue: initialIncomeValue,
                unemploymentValue: initialUnemploymentValue,
                ownedValue: initialOwnedValue,
                educationValue: initialEducationValue,
                areaDetailed: initialAreaDetailed,
            }));
    }, []);

    const currentFormStateKey = serializeFormState({
        houseType,
        priceMin,
        priceMax,
        roomMin,
        roomMax,
        sqmMin,
        sqmMax,
        feeMax,
        sqmPriceMin,
        sqmPriceMax,
        floorMin,
        floorMax,
        yearBuiltMin,
        yearBuiltMax,
        balcony,
        elevator,
        newConstruction,
        totalValue,
        apartmentValue,
        houseValue,
        incomeValue,
        unemploymentValue,
        ownedValue,
        educationValue,
        areaDetailed,
    });
    // Restid till jobbet is edited as a draft too (commute.js); these re-render the drawer when it changes.
    useCommuteDraft();
    useCommute();
    const hasPendingApplyChanges = currentFormStateKey !== appliedFormStateKey || isCommuteDraftPending();

    // The filters as applied: only the area scores on show count (the total, or the detailed ones);
    // the others are sent as the full range.
    const buildAppliedFilters = () => {
        const shown = (range, isShown) => (isShown ? range : FULL_RANGE);
        const total = shown(totalValue, !areaDetailed);
        const apartment = shown(apartmentValue, areaDetailed);
        const house = shown(houseValue, areaDetailed);
        const education = shown(educationValue, areaDetailed);
        const owned = shown(ownedValue, areaDetailed);
        const income = shown(incomeValue, areaDetailed);
        const unemployment = shown(unemploymentValue, areaDetailed);
        return {
            newState: {
                house,
                apartment,
                education,
                owned,
                income,
                unemployment,
                totalScore: total,
            },
            listingState: {
                houseType,
                priceMin,
                priceMax,
                roomMin,
                roomMax,
                sqmMin,
                sqmMax,
                feeMax,
                sqmPriceMin,
                sqmPriceMax,
                floorMin,
                floorMax,
                yearBuiltMin,
                yearBuiltMax,
                balcony,
                elevator,
                newConstruction,
                totalValue: total,
                apartmentValue: apartment,
                houseValue: house,
                incomeValue: income,
                unemploymentValue: unemployment,
                ownedValue: owned,
                educationValue: education,
            },
        };
    };

    useEffect(() => {
        if (prevOpenRef.current && !open) {
            if (hasPendingApplyChanges) onBeforeApply?.();
            applyCommuteDraft();
            const { newState, listingState } = buildAppliedFilters();
            setCustomFilterActive(true);
            setCustomFilter(newState);
            if (setListingFilters) {
                setListingFilters(listingState);
            }
            setKey((prevKey) => prevKey + 1);
            saveFilters(newState, listingState);
            setAppliedFormStateKey(serializeFormState({
                houseType,
                priceMin,
                priceMax,
                roomMin,
                roomMax,
                sqmMin,
                sqmMax,
                feeMax,
                sqmPriceMin,
                sqmPriceMax,
                floorMin,
                floorMax,
                yearBuiltMin,
                yearBuiltMax,
                balcony,
                elevator,
                newConstruction,
                totalValue,
                apartmentValue,
                houseValue,
                incomeValue,
                unemploymentValue,
                ownedValue,
                educationValue,
                areaDetailed,
            }));
        }
        prevOpenRef.current = open;
    }, [open, houseValue, apartmentValue, educationValue, ownedValue, incomeValue, unemploymentValue, totalValue, areaDetailed, houseType, priceMin, priceMax, roomMin, roomMax, sqmMin, sqmMax, feeMax, sqmPriceMin, sqmPriceMax, floorMin, floorMax, yearBuiltMin, yearBuiltMax, balcony, elevator, newConstruction, setCustomFilterActive, setCustomFilter, setListingFilters, setKey, cookies]);

    const handleAreaDetailed = () => {
        const next = !areaDetailed;
        setAreaDetailed(next);
        cookies.set(AREA_DETAILED_COOKIE, next ? 'true' : 'false', { path: '/', maxAge: 60 * 60 * 24 * 365 });
        track('filter.detailed', { on: next });
    };

    const handleTabClick = (name) => {
        if (name === "exit") {
            setOpen(false);
        } else {
            setDrawerTab(name);
            setSelectedTab(name);
        }
    }

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    }

    const handleFormSubmit = () => {
        if (hasPendingApplyChanges) onBeforeApply?.();
        applyCommuteDraft();
        const { newState, listingState } = buildAppliedFilters();

        // Activate the custom filter
        setCustomFilterActive(true);

        // Update the state with the new filter
        setCustomFilter(newState);
        if (setListingFilters) {
            setListingFilters(listingState);
        }

        // Update a key to trigger necessary re-renders or actions
        setKey((prevKey) => prevKey + 1);

        // Save the state to cookies
        saveFilters(newState, listingState);
        setAppliedFormStateKey(currentFormStateKey);
        if (typeof onApplyListingSearch === 'function') {
            onApplyListingSearch();
        }

        setOpen(false);
    };

    // Home type is multi-select: "Alla" is exclusive, the four specific types combine. The value is 'all'
    // or a comma-list in canonical order (apartments,houses,rowhouse,fritidshus); picking all four collapses to 'all'.
    const HOUSE_TYPE_KEYS = ['apartments', 'houses', 'rowhouse', 'fritidshus'];
    const selectedHouseTypes = houseType === 'all' ? [] : String(houseType).split(',').filter((key) => HOUSE_TYPE_KEYS.includes(key));
    const isHouseTypeActive = (key) => (key === 'all' ? houseType === 'all' : selectedHouseTypes.includes(key));
    const handleHouseType = (type) => {
        if (type === 'all') {
            setHosueType('all');
            return;
        }
        const next = selectedHouseTypes.includes(type)
            ? selectedHouseTypes.filter((key) => key !== type)
            : [...selectedHouseTypes, type];
        if (next.length === 0 || next.length === HOUSE_TYPE_KEYS.length) {
            setHosueType('all');
        } else {
            setHosueType(HOUSE_TYPE_KEYS.filter((key) => next.includes(key)).join(','));
        }
    };


    const handleRoomeMin = (event) => {
        setRoomMin(event.target.value)
    }
    const handleRoomeMax = (event) => {
        setRoomMax(event.target.value)
    }

    const handleSqmMin = (event) => {
        setSqmMin(event.target.value);
    };

    const handleSqmMax = (event) => {
        setSqmMax(event.target.value);
    };



    const btnGrp = () => {

        return (
            <div className="drawer-btn-wrapper">
                <Tabs value={value} onChange={handleTabChange} centered>
                <Tab onClick={() => handleTabClick("house")}
                     label={languageState.swedish ? "Bostadsfilter" : "Listing filters"}
                     value="one"/>
                <Tab onClick={() => handleTabClick("map")}
                     label={languageState.swedish ? "Kartfilter" : "Map filters"}
                     value="two"/>
                    <Button onClick={() => handleTabClick("exit")} style={{width: '20%'}}><CloseIcon/></Button>
                </Tabs>
            </div>
        );
    }

    // The bars follow everything in the drawer as it is being set, except the price.
    const appliedListingState = buildAppliedFilters().listingState;
    const { priceMin: _ignoredMin, priceMax: _ignoredMax, ...priceHistogramFilters } = appliedListingState;
    const { feeMax: _ignoredFee, ...feeHistogramFilters } = appliedListingState;

    function getSelectBoxes() {
        return (
            <div className="drawer-section drawer-section--price">
                <div className="drawer-select-box-wrapper">
                <PriceRangeBar
                    priceMin={priceMin}
                    priceMax={priceMax}
                    onChange={(min, max) => {
                        setPriceMin(min);
                        setPriceMax(max);
                    }}
                    filters={priceHistogramFilters}
                    getPriceHistogram={getPriceHistogram}
                    histogramScope={priceHistogramScope}
                    swedish={languageState.swedish}
                />
                <FeeRangeBar
                    feeMax={feeMax}
                    onChange={setFeeMax}
                    filters={feeHistogramFilters}
                    getPriceHistogram={getPriceHistogram}
                    histogramScope={priceHistogramScope}
                    swedish={languageState.swedish}
                />
                <p className="drawer-filter-desc">{languageState.swedish ? 'Rum' : 'Rooms'}</p>
                <div className="drawer-select-box-row">
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={roomMin}
                        onChange={handleRoomeMin}
                        style={{height: '34px', width: '45%'}}
                    >
                        <MenuItem value={"min"}>{languageState.swedish ? 'Minsta' : 'Min'}</MenuItem>
                        <MenuItem value={1} disabled={1 > roomMax && roomMax !== "max"}>1</MenuItem>
                        <MenuItem value={1.5} disabled={1.5 > roomMax && roomMax !== "max"}>{languageState.swedish ? '1,5' : '1.5'}</MenuItem>
                        <MenuItem value={2} disabled={2 > roomMax && roomMax !== "max"}>2</MenuItem>
                        <MenuItem value={2.5} disabled={2.5 > roomMax && roomMax !== "max"}>{languageState.swedish ? '2,5' : '2.5'}</MenuItem>
                        <MenuItem value={3} disabled={3 > roomMax && roomMax !== "max"}>3</MenuItem>
                        <MenuItem value={3.5} disabled={3.5 > roomMax && roomMax !== "max"}>{languageState.swedish ? '3,5' : '3.5'}</MenuItem>
                        <MenuItem value={4} disabled={4 > roomMax && roomMax !== "max"}>4</MenuItem>
                        <MenuItem value={4.5} disabled={4.5 > roomMax && roomMax !== "max"}>{languageState.swedish ? '4,5' : '4.5'}</MenuItem>
                        <MenuItem value={5} disabled={5 > roomMax && roomMax !== "max"}>5</MenuItem>
                        <MenuItem value={6} disabled={6 > roomMax && roomMax !== "max"}>6</MenuItem>
                        <MenuItem value={7} disabled={7 > roomMax && roomMax !== "max"}>7</MenuItem>
                        <MenuItem value={8} disabled={8 > roomMax && roomMax !== "max"}>8</MenuItem>
                        <MenuItem value={9} disabled={9 > roomMax && roomMax !== "max"}>9</MenuItem>
                        <MenuItem value={10} disabled={10 > roomMax && roomMax !== "max"}>10</MenuItem>
                        <MenuItem value={11} disabled={11 > roomMax && roomMax !== "max"}>11</MenuItem>
                        <MenuItem value={12} disabled={12 > roomMax && roomMax !== "max"}>12</MenuItem>
                        <MenuItem value={13} disabled={13 > roomMax && roomMax !== "max"}>13</MenuItem>
                        <MenuItem value={14} disabled={14 > roomMax && roomMax !== "max"}>14</MenuItem>
                        <MenuItem value={15} disabled={15 > roomMax && roomMax !== "max"}>15</MenuItem>
                        <MenuItem value={20} disabled={20 > roomMax && roomMax !== "max"}>20</MenuItem>
                    </Select>
                    <RemoveIcon style={{alignSelf: 'center'}}/>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={roomMax}
                        onChange={handleRoomeMax}
                        style={{height: '34px', width: '45%'}}
                    >
                        <MenuItem value={"max"}>{languageState.swedish ? 'Högsta' : 'Max'}</MenuItem>
                        <MenuItem value={1} disabled={1 < roomMin && roomMin !== "min"}>1</MenuItem>
                        <MenuItem value={1.5} disabled={1.5 < roomMin && roomMin !== "min"}>{languageState.swedish ? '1,5' : '1.5'}</MenuItem>
                        <MenuItem value={2} disabled={2 < roomMin && roomMin !== "min"}>2</MenuItem>
                        <MenuItem value={2.5} disabled={2.5 < roomMin && roomMin !== "min"}>{languageState.swedish ? '2,5' : '2.5'}</MenuItem>
                        <MenuItem value={3} disabled={3 < roomMin && roomMin !== "min"}>3</MenuItem>
                        <MenuItem value={3.5} disabled={3.5 < roomMin && roomMin !== "min"}>{languageState.swedish ? '3,5' : '3.5'}</MenuItem>
                        <MenuItem value={4} disabled={4 < roomMin && roomMin !== "min"}>4</MenuItem>
                        <MenuItem value={4.5} disabled={4.5 < roomMin && roomMin !== "min"}>{languageState.swedish ? '4,5' : '4.5'}</MenuItem>
                        <MenuItem value={5} disabled={5 < roomMin && roomMin !== "min"}>5</MenuItem>
                        <MenuItem value={6} disabled={6 < roomMin && roomMin !== "min"}>6</MenuItem>
                        <MenuItem value={7} disabled={7 < roomMin && roomMin !== "min"}>7</MenuItem>
                        <MenuItem value={8} disabled={8 < roomMin && roomMin !== "min"}>8</MenuItem>
                        <MenuItem value={9} disabled={9 < roomMin && roomMin !== "min"}>9</MenuItem>
                        <MenuItem value={10} disabled={10 < roomMin && roomMin !== "min"}>10</MenuItem>
                        <MenuItem value={11} disabled={11 < roomMin && roomMin !== "min"}>11</MenuItem>
                        <MenuItem value={12} disabled={12 < roomMin && roomMin !== "min"}>12</MenuItem>
                        <MenuItem value={13} disabled={13 < roomMin && roomMin !== "min"}>13</MenuItem>
                        <MenuItem value={14} disabled={14 < roomMin && roomMin !== "min"}>14</MenuItem>
                        <MenuItem value={15} disabled={15 < roomMin && roomMin !== "min"}>15</MenuItem>
                        <MenuItem value={20} disabled={20 < roomMin && roomMin !== "min"}>20</MenuItem>
                    </Select>
                </div>
                <p className="drawer-filter-desc">{languageState.swedish ? 'Boarea' : 'Area'} (m²)</p>
                <div className="drawer-select-box-row">
                    <Select
                        labelId="sqm-min-select-label"
                        id="sqm-min-select"
                        value={sqmMin}
                        onChange={handleSqmMin}
                        style={{height: '34px', width: '45%'}}
                    >
                        <MenuItem value={"min"}>{languageState.swedish ? 'Minsta' : 'Min'}</MenuItem>
                        {sqmOptions.map((value) => (
                            <MenuItem key={`sqm-min-${value}`} value={value} disabled={sqmMax !== "max" && value > sqmMax}>
                                {value} m²
                            </MenuItem>
                        ))}
                    </Select>
                    <RemoveIcon style={{alignSelf: 'center'}}/>
                    <Select
                        labelId="sqm-max-select-label"
                        id="sqm-max-select"
                        value={sqmMax}
                        onChange={handleSqmMax}
                        style={{height: '34px', width: '45%'}}
                    >
                        <MenuItem value={"max"}>{languageState.swedish ? 'Högsta' : 'Max'}</MenuItem>
                        {sqmOptions.map((value) => (
                            <MenuItem key={`sqm-max-${value}`} value={value} disabled={sqmMin !== "min" && value < sqmMin}>
                                {value} m²
                            </MenuItem>
                        ))}
                    </Select>
                </div>
                <p className="drawer-filter-desc">{languageState.swedish ? 'Pris per m²' : 'Price per m²'}</p>
                <div className="drawer-select-box-row">
                    <Select
                        id="sqm-price-min-select"
                        value={sqmPriceMin}
                        onChange={(event) => setSqmPriceMin(event.target.value)}
                        style={{height: '34px', width: '45%'}}
                        inputProps={{ 'aria-label': languageState.swedish ? 'Lägsta pris per m²' : 'Min price per m²' }}
                    >
                        <MenuItem value={"min"}>{languageState.swedish ? 'Minsta' : 'Min'}</MenuItem>
                        {sqmPriceOptions.map((value) => (
                            <MenuItem key={`sqm-price-min-${value}`} value={value} disabled={sqmPriceMax !== "max" && value > sqmPriceMax}>
                                {`${formatKronor(value)} kr`}
                            </MenuItem>
                        ))}
                    </Select>
                    <RemoveIcon style={{alignSelf: 'center'}}/>
                    <Select
                        id="sqm-price-max-select"
                        value={sqmPriceMax}
                        onChange={(event) => setSqmPriceMax(event.target.value)}
                        style={{height: '34px', width: '45%'}}
                        inputProps={{ 'aria-label': languageState.swedish ? 'Högsta pris per m²' : 'Max price per m²' }}
                    >
                        <MenuItem value={"max"}>{languageState.swedish ? 'Högsta' : 'Max'}</MenuItem>
                        {sqmPriceOptions.map((value) => (
                            <MenuItem key={`sqm-price-max-${value}`} value={value} disabled={sqmPriceMin !== "min" && value < sqmPriceMin}>
                                {`${formatKronor(value)} kr`}
                            </MenuItem>
                        ))}
                    </Select>
                </div>
                <p className="drawer-filter-desc">{languageState.swedish ? 'Våning' : 'Floor'}</p>
                <div className="drawer-select-box-row">
                    <Select
                        id="floor-min-select"
                        value={floorMin}
                        onChange={(event) => setFloorMin(event.target.value)}
                        style={{height: '34px', width: '45%'}}
                        inputProps={{ 'aria-label': languageState.swedish ? 'Lägsta våning' : 'Lowest floor' }}
                    >
                        <MenuItem value={"min"}>{languageState.swedish ? 'Lägsta' : 'Lowest'}</MenuItem>
                        {floorOptions.map((value) => (
                            <MenuItem key={`floor-min-${value}`} value={value} disabled={floorMax !== "max" && value > floorMax}>
                                {floorLabel(value)}
                            </MenuItem>
                        ))}
                    </Select>
                    <RemoveIcon style={{alignSelf: 'center'}}/>
                    <Select
                        id="floor-max-select"
                        value={floorMax}
                        onChange={(event) => setFloorMax(event.target.value)}
                        style={{height: '34px', width: '45%'}}
                        inputProps={{ 'aria-label': languageState.swedish ? 'Högsta våning' : 'Highest floor' }}
                    >
                        <MenuItem value={"max"}>{languageState.swedish ? 'Högsta' : 'Highest'}</MenuItem>
                        {floorOptions.map((value) => (
                            <MenuItem key={`floor-max-${value}`} value={value} disabled={floorMin !== "min" && value < floorMin}>
                                {floorLabel(value)}
                            </MenuItem>
                        ))}
                    </Select>
                </div>
                <p className="drawer-filter-desc">{languageState.swedish ? 'Byggår' : 'Year built'}</p>
                <div className="drawer-select-box-row">
                    <Select
                        id="year-built-min-select"
                        value={yearBuiltMin}
                        onChange={(event) => setYearBuiltMin(event.target.value)}
                        style={{height: '34px', width: '45%'}}
                        inputProps={{ 'aria-label': languageState.swedish ? 'Byggt tidigast' : 'Built earliest' }}
                    >
                        <MenuItem value={"min"}>{languageState.swedish ? 'Tidigast' : 'Earliest'}</MenuItem>
                        {yearBuiltOptions.map((value) => (
                            <MenuItem key={`year-built-min-${value}`} value={value} disabled={yearBuiltMax !== "max" && value > yearBuiltMax}>
                                {value}
                            </MenuItem>
                        ))}
                    </Select>
                    <RemoveIcon style={{alignSelf: 'center'}}/>
                    <Select
                        id="year-built-max-select"
                        value={yearBuiltMax}
                        onChange={(event) => setYearBuiltMax(event.target.value)}
                        style={{height: '34px', width: '45%'}}
                        inputProps={{ 'aria-label': languageState.swedish ? 'Byggt senast' : 'Built latest' }}
                    >
                        <MenuItem value={"max"}>{languageState.swedish ? 'Senast' : 'Latest'}</MenuItem>
                        {yearBuiltOptions.map((value) => (
                            <MenuItem key={`year-built-max-${value}`} value={value} disabled={yearBuiltMin !== "min" && value < yearBuiltMin}>
                                {value}
                            </MenuItem>
                        ))}
                    </Select>
                </div>
                <p className="drawer-filter-desc">{languageState.swedish ? 'Nyproduktion' : 'New builds'}</p>
                <div className="drawer-select-box-row">
                    <Select
                        id="new-construction-select"
                        value={newConstruction}
                        onChange={(event) => setNewConstruction(event.target.value)}
                        style={{height: '36px', width: '100%'}}
                        inputProps={{ 'aria-label': languageState.swedish ? 'Nyproduktion' : 'New builds' }}
                    >
                        <MenuItem value="all">{languageState.swedish ? 'Visa alla' : 'Show all'}</MenuItem>
                        <MenuItem value="only">{languageState.swedish ? 'Bara nyproduktion' : 'New builds only'}</MenuItem>
                        <MenuItem value="exclude">{languageState.swedish ? 'Ingen nyproduktion' : 'No new builds'}</MenuItem>
                    </Select>
                </div>
                <div className="drawer-check-row">
                    <FormControlLabel
                        control={<Checkbox size="small" checked={balcony} onChange={(event) => setBalcony(event.target.checked)} />}
                        label={(
                            <span className="drawer-check-label">
                                <BalconyOutlinedIcon fontSize="small" aria-hidden="true" />
                                {languageState.swedish ? 'Balkong' : 'Balcony'}
                            </span>
                        )}
                    />
                    <FormControlLabel
                        control={<Checkbox size="small" checked={elevator} onChange={(event) => setElevator(event.target.checked)} />}
                        label={(
                            <span className="drawer-check-label">
                                <ElevatorOutlinedIcon fontSize="small" aria-hidden="true" />
                                {languageState.swedish ? 'Hiss' : 'Elevator'}
                            </span>
                        )}
                    />
                </div>
                </div>
            </div>
        );
    }

    function getList() {
        const swedish = languageState.swedish;
        const detailedBars = [
            { key: 'income', label: swedish ? 'Inkomst' : 'Income', value: incomeValue, set: setIncomeValue },
            { key: 'education', label: swedish ? 'Utbildning' : 'Education', value: educationValue, set: setEducationValue },
            { key: 'unemployment', label: swedish ? 'Sysselsättning' : 'Employment', value: unemploymentValue, set: setUnemploymentValue },
            { key: 'owned', label: swedish ? 'Ägt boende' : 'Owned homes', value: ownedValue, set: setOwnedValue },
            { key: 'apartment', label: swedish ? 'Lägenhetspris (kr/m²)' : 'Apartment price (SEK/m²)', value: apartmentValue, set: setApartmentValue },
            { key: 'house', label: swedish ? 'Villapris (kr/m²)' : 'House price (SEK/m²)', value: houseValue, set: setHouseValue },
        ];
        const areaSwitch = (
            <button
                type="button"
                role="switch"
                aria-checked={areaDetailed}
                className="drawer-area-switch"
                onClick={handleAreaDetailed}
            >
                {swedish ? 'Detaljerat' : 'Detailed'}
                <span className="drawer-area-switch-track" aria-hidden="true">
                    <span className="drawer-area-switch-knob" />
                </span>
            </button>
        );
        return (
            <div
                className="drawer-section drawer-section--sliders drawer-section--area"
                title={swedish ? 'Visa bara bostäder i områden du trivs i' : 'Only show homes in areas you like'}
            >
                {areaDetailed ? (
                    <>
                        <div className="drawer-area-head">
                            <span className="drawer-area-title">{swedish ? 'Områdesbetyg' : 'Area score'}</span>
                            {areaSwitch}
                        </div>
                        <div className="drawer-area-bars">
                            {detailedBars.map((bar) => (
                                <ScoreRangeBar
                                    key={bar.key}
                                    label={bar.label}
                                    value={bar.value}
                                    onChange={bar.set}
                                    swedish={swedish}
                                />
                            ))}
                            <p className="drawer-area-note">
                                {swedish
                                    ? 'Totalbetyget används inte när Detaljerat är på.'
                                    : 'The total score is not used while Detailed is on.'}
                            </p>
                        </div>
                    </>
                ) : (
                    <ScoreRangeBar
                        label={swedish ? 'Områdesbetyg' : 'Area score'}
                        value={totalValue}
                        onChange={setTotalValue}
                        swedish={swedish}
                        size="large"
                        headExtra={areaSwitch}
                    />
                )}
            </div>
        );
    }

    const HOME_TYPE_TABS = [
        {
            key: 'all',
            sv: 'Alla',
            en: 'All',
            icon: <HomeTypeIcon type="all" />,
        },
        {
            key: 'apartments',
            sv: 'Lägenhet',
            en: 'Apartment',
            icon: <HomeTypeIcon type="apartment" />,
        },
        {
            key: 'houses',
            sv: 'Villa',
            en: 'House',
            icon: <HomeTypeIcon type="house" />,
        },
        {
            key: 'rowhouse',
            sv: 'Par/radhus',
            en: 'Row house',
            icon: <HomeTypeIcon type="rowhouse" />,
        },
        {
            key: 'fritidshus',
            sv: 'Fritidshus',
            en: 'Holiday home',
            icon: <HomeTypeIcon type="fritidshus" />,
        },
    ];

    function getBuildingType() {
        return (
            <div className="drawer-section drawer-section--type is-compact">
                <div className="drawer-type-tabs" role="group" aria-label={languageState.swedish ? 'Bostadstyp' : 'Home type'}>
                    {HOME_TYPE_TABS.map((tab) => (
                        <button
                            key={tab.key}
                            type="button"
                            aria-pressed={isHouseTypeActive(tab.key)}
                            className={`drawer-type-tab${isHouseTypeActive(tab.key) ? ' is-active' : ''}`}
                            onClick={() => handleHouseType(tab.key)}
                        >
                            {tab.icon}
                            {languageState.swedish ? tab.sv : tab.en}
                        </button>
                    ))}
                </div>
            </div>
        );
    }

    function getMapSwitches() {
        return (
            <div className="drawer-section drawer-section--toggles">
                <div className="drawer-section-header">
                    <div className="drawer-section-title">
                        {languageState.swedish ? 'Färgkarta' : 'Color map'}
                    </div>
                    {getInfoIcon('mapLegend')}
                </div>
                <List className="drawer-list">
                    {[
                        {
                            text: languageState.swedish ? 'Betyg' : 'Total Score',
                            icon: <StarIcon sx={{height:'20px', width:'20px'}}/>,
                            key: 'totalScore'
                        },
                        {
                            text: languageState.swedish ? 'Lägenhet kr/m²' : 'Apartment SEK/m²',
                            icon: <HomeTypeSvgIcon type="apartment" sx={{height:'20px', width:'20px'}}/>,
                            key: 'squareMeterPriceApartment'
                        },
                        {
                            text: languageState.swedish ? 'Hus kr/m²' : 'House SEK/m²',
                            icon: <HomeTypeSvgIcon type="house" sx={{height:'20px', width:'20px'}}/>,
                            key: 'squareMeterPriceHouse'
                        },
                        {
                            text: languageState.swedish ? 'Nettoinkomst' : 'Net Income',
                            icon: <WalletIcon sx={{height:'20px', width:'20px'}}/>,
                            key: 'income'
                        },
                        {
                            text: languageState.swedish ? 'Arbetslöshet' : 'Unemployment',
                            icon: <WorkOutlineIcon sx={{height:'20px', width:'20px'}}/>,
                            key: 'unemployment'
                        },
                        {
                            text: languageState.swedish ? 'Boendeform (ägande)' : 'Housing type (ownership)',
                            icon: <VpnKeyIcon sx={{height:'20px', width:'20px'}}/>,
                            key: 'ownedVsRented'
                        },
                        {
                            text: languageState.swedish ? 'Andel högutbildade' : 'Higher Education',
                            icon: <SchoolIcon sx={{height:'20px', width:'20px'}}/>,
                            key: 'education'
                        }
                    ].map(({text, icon, key}) => (
                        <ListItem key={text} disablePadding style={{height:'35px'}}>
                            <ListItemButton className="drawer-toggle-row">
                                <ListItemIcon>
                                    {icon}
                                </ListItemIcon>
                                <ListItemText primary={text} />
                                <Switch checked={checkedState[key]}
                                        onChange={handleChange}
                                        name={key}
                                        style={{
                                            position: 'absolute',
                                            padding: '9px',
                                            color: 'var(--header-color)',
                                            borderRadius: '50%',
                                        }}/>
                                {getInfoIcon(key)}
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </div>
                );
    }


        return (
            <div className="drawer-wrapper">
                <div className="drawer-panel">
                    <div className="drawer-header">
                        <div>
                            <div className="drawer-title">{languageState.swedish ? 'Bostadsfilter' : 'Listing filters'}</div>
                        </div>
                        <button className="drawer-close" type="button" onClick={() => setOpen(false)}>
                            <CloseIcon fontSize="small" />
                        </button>
                    </div>
                    <div className="drawer-content">
                        {!betaVersion && selectedTab === "house" && getBuildingType()}
                        {!betaVersion && selectedTab === "house" && getList()}
                        {!betaVersion && selectedTab === "house" && <CommuteFilter languageState={languageState} introTip={commuteIntroTip} />}
                        {!betaVersion && selectedTab === "house" && getSelectBoxes()}
                        {!betaVersion && selectedTab === "house" && showMapSwitches && getMapSwitches()}

                        {betaVersion && selectedTab === "house" && getList()}
                        {betaVersion && selectedTab === "house" && getMapSwitches()}
                    </div>
                    {expandToggle}
                    {selectedTab === "house" &&
                        <Button onClick={handleFormSubmit} className={`drawer-apply-button${hasPendingApplyChanges ? ' is-pending-apply' : ' is-idle'}`} style={{
                            backgroundColor:'var(--header-color)',
                            color:'#ffffff',
                        }}>{betaVersion ? (languageState.swedish ? "Applicera Filter!" : "Apply filters!") : (languageState.swedish ? "Sök bostäder!" : "Search listings!")}</Button>}
                </div>
            </div>
        );
};

export default FilterList;
